import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Sign-up — pre-auth acquisition flow. Rendered under SignUpLayout (trust-dossier shell).
export const signUpRoutes: RouteRecordRaw[] = [
  {
    path: routes.SIGNUP,
    name: 'SIGNUP',
    component: () => import('./SignUpPage.vue'),
    meta: { requiresGuest: true, layout: 'signup' },
  },
  // UAE Pass sign-up confirm — reached from the UAE Pass callback with a verified
  // identity; provisions the account and lands on the "account created" screen.
  {
    path: routes.UAE_PASS_SIGNUP,
    name: 'UAE_PASS_SIGNUP',
    component: () => import('./UaePassSignUpPage.vue'),
    meta: { requiresGuest: true, layout: 'signup' },
  },
]

// Post-signup KYC wizard — rendered under OnboardingLayout.
export const onboardingWizardRoutes: RouteRecordRaw[] = [
  {
    path: routes.ONBOARDING_WIZARD,
    name: 'ONBOARDING_WIZARD',
    component: () => import('./OnboardingWizardPage.vue'),
    meta: { requiresAuth: true, layout: 'onboarding' },
  },
]

// Standalone risk-profile completion — entered from the dashboard nudge when
// the optional risk_profiling step was skipped during onboarding. Rendered
// under the default app layout (the investor is past the wizard by now).
export const riskProfileRoutes: RouteRecordRaw[] = [
  {
    path: routes.RISK_PROFILE,
    name: 'RISK_PROFILE',
    component: () => import('./RiskProfilePage.vue'),
    meta: { requiresAuth: true },
  },
]

// Aggregate for any consumer that still needs the full set.
export const onboardingRoutes: RouteRecordRaw[] = [
  ...signUpRoutes,
  ...onboardingWizardRoutes,
  ...riskProfileRoutes,
]
